import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import { BankInfos } from "../../../models/cartable.model";
import BankInfoActionButtons from "../../../components/actionButtons/BankInfoActionButtons";

interface Props {
  data: BankInfos;
  setReload: (reload: string) => void;
}
const BankInfo = ({ data, setReload }: Props) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
        height: "100%",
      }}
    >
      {data.loanInfoActions.length > 0 && (
        <Box sx={{ height: "10%" }}>
          <BankInfoActionButtons
            setReload={setReload}
            loanInfoActions={
              (data?.loanInfoActions as unknown) as Pick<
                BankInfos,
                "loanInfoActions"
              >
            }
          />
        </Box>
      )}
      <Box sx={{ height: "85%", overflowY: "auto" }}>
        <Grid container>
          {data?.loanInfoItems?.map((item) => (
            <Grid
              item
              sx={{
                display: "flex",
                width: "100%",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "20px",
                border: "1px solid #DAE0E4",
                borderTop:
                  data?.loanInfoItems.indexOf(item) === 0
                    ? "1px solid #DAE0E4"
                    : "none",
              }}
            >
              <Typography
                sx={{ color: "#757575", fontSize: "1.1rem", fontWeight: "600" }}
              >
                {item.title}
              </Typography>
              <Typography sx={{ color: "#757575", fontSize: "1.1rem" }}>
                {item.url ? (
                  <a href={item.url} target="_blank" rel="noopener noreferrer">
                    {item.value}
                  </a>
                ) : (
                  item.value
                )}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default BankInfo;
